var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('svg',{staticClass:"animate-spin h-5 w-5 mr-3 ...",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"}})]),_vm._v(" Cargando ")])}
var staticRenderFns = []

export { render, staticRenderFns }